import { NgForm } from "@angular/forms";
import { OnInit, ViewChild, Component, Input, Output, EventEmitter } from "@angular/core";
import { StructureUserRole } from "../../../structure/structure-users.model";
import { UserDetailsRest } from "../user-details.rest";
import { ModalComponent } from "../../../../core/shared/modal/modal.component";
import { DateInputModel } from "../../../../core/shared/date-input/date-input.model";
import { UserPositionRow } from "../../users.model";

const dateFromInternalName : string = 'DateFrom';
const dateToInternalName : string = 'DateTo';

@Component({
    selector: 'smp-user-position',
    templateUrl: 'user-details-position.component.html',
})

export class UserDetailsPositionComponent implements OnInit {
    
    private userPosition: any = {'userRoleId': 0};
    private roles: StructureUserRole[];
    private editMode: boolean;
    @Output() onSuccess = new EventEmitter();
    @Input() private dateFrom : DateInputModel;
    @Input() private dateTo : DateInputModel;
    @ViewChild(ModalComponent) private modal: ModalComponent;
    @ViewChild('positionForm') positionForm: NgForm;

    constructor(
        private rest: UserDetailsRest) { }

    public ngOnInit() {
        this.rest.getUserRoles().subscribe(roles => {
         this.roles = roles;      
        });
    }

    public openForAdding(userName: any) { 
        this.editMode = false;
        this.userPosition = new UserPositionRow();
        var today = new Date();
        //var dd = today.getDate();
        this.userPosition.dateFrom = today;
        this.userPosition.dateTo = today;

        //this.modal.openWithCustomSize({'width': '400px'}); 
        this.modal.title = 'Dodaj zatrudnienie';
        this.modal.open();  
        this.initData();  
        this.userPosition.userName = userName;                 
    }

    public openForEdit(userPosition: UserPositionRow) {      
        this.editMode = true;
        this.userPosition = {
            id: userPosition.id,
            dateFrom: userPosition.dateFrom,
            dateTo: userPosition.dateTo,
            roleName: userPosition.roleName,
            userId: userPosition.userId,
            userRoleId: userPosition.userRoleId,
            salary: userPosition.salary
        };     
        //this.modal.openWithCustomSize({'width': '400px'});
        this.modal.title = 'Edytuj zatrudnienie';
        this.modal.open();
        this.initData();
    }
    
    public initData()
    {     
        this.dateFrom = new DateInputModel();
        //this.dateFrom.isReadOnly = this.isReadOnly;
        this.dateFrom.isRequired = true;
        this.dateFrom.name = 'Od:';  
        this.dateFrom.value = new Date(this.userPosition.dateFrom); 
        this.dateFrom.valueStr = this.userPosition.dateFrom;         
        this.dateFrom.withTime = false;
        this.dateFrom.internalName = dateFromInternalName;

        this.dateTo = new DateInputModel();
        //this.dateFrom.isReadOnly = this.isReadOnly;
        this.dateTo.isRequired = true;
        this.dateTo.name = 'Do:';   
        this.dateTo.valueStr = this.userPosition.dateTo;
        this.dateTo.value = new Date(this.userPosition.dateTo);
        this.dateTo.withTime = false;
        this.dateTo.internalName = dateToInternalName;
    }   

    public saveUserPosition() {  
        const action = this.editMode ? this.rest.editUserPosition : this.rest.addUserPosition;
        action.call(this.rest, this.userPosition).subscribe(() => {
            this.modal.close();        
            this.onSuccess.emit();
        });
    }

    public getDisabledStatus() {
    }

    public closeModal() {
        this.modal.close();
    }

    private onElementValidation(element, isValid: boolean) {

        if (!element)
        return;

        if (element.internalName == dateFromInternalName) { 
            this.userPosition.dateFromStr = element.valueStr;
            this.userPosition.dateFrom = element.value;
        }
        else if (element.internalName == dateToInternalName) {
            this.userPosition.dateToStr = element.valueStr;
            this.userPosition.dateTo = element.value;
        }        
    }
}
